import moment from "moment";

// group options
export const GROUP_BY_TIME = "time";
export const GROUP_BY_SURVEY = "survey";
export const GROUP_OPTIONS = [GROUP_BY_TIME, GROUP_BY_SURVEY];
// timeline item
export const DAY_ITEM = "day";
export const EVENT_ITEM = "event";
const eventItems = {
  0: "surveyAnswer",
  1: "intakeAnswer",
  2: "buttonAnswer",
  3: "appletAnswer",
  4: "installButton",
  5: "installApplet",
  6: "note",
};

const groupBy = (x, f) => x.reduce((a, b) => ((a[f(b)] ||= []).push(b), a), {});
const getMoment = (time) => moment.utc(time).locale("nl");

export default function importTimeline({ type, payload }) {
  const timeline = payload.events.sort((a, b) => b.time - a.time);
  const interactions = timeline.filter((event) =>
    [0, 1, 2, 3].includes(event.type)
  );
  const groupResponsesByItemId = groupBy(
    interactions,
    (response) => response.itemId
  );
  const itemIds = Object.keys(groupResponsesByItemId);

  // events: responses, installs, and notes
  const responses =
    type === GROUP_BY_SURVEY
      ? itemIds.map((itemId) => groupResponsesByItemId[itemId].at(0)) // latestResponses
      : interactions; // all responses
  const installs = timeline.filter((event) => [4, 5].includes(event.type)); // install of buttons and applets
  const notes = payload.notes.map((note) => ({
    ...note,
    itemId: note.id,
    type: 6,
  })); // practitioner notes

  const format = type === GROUP_BY_SURVEY ? "MM/YYYY" : "YYYY";
  const events = [...responses, ...installs, ...notes]
    .sort((a, b) => b.time - a.time)
    .map((event) => ({
      ...event,
      filterKey: getMoment(event.time).format(format),
    }));
  const groupEventsByFilterKey = groupBy(events, (event) => event.filterKey);
  const filterKeys =
    type === GROUP_BY_SURVEY
      ? Object.keys(groupEventsByFilterKey)
      : Object.keys(groupEventsByFilterKey).reverse();
  let renderTimeline = [];
  for (let i = 0; i < filterKeys.length; i++) {
    const key = filterKeys[i];
    renderTimeline.push({
      type: DAY_ITEM,
      event: groupEventsByFilterKey[key][0],
    });
    for (let j = 0; j < groupEventsByFilterKey[key].length; j++) {
      const event = groupEventsByFilterKey[key][j];
      renderTimeline.push({
        type: EVENT_ITEM,
        event: event,
        surveys: groupResponsesByItemId?.[event.itemId] ?? [],
        isFirstEventItem: j === 0,
        isLastEventItem: groupEventsByFilterKey[key].length === j + 1,
        isLastDateItem: filterKeys.length === i + 1,
        initExpanded: i === 0 && j === 0,
      });
    }
  }
  //console.log(groupEventsByFilterKey);
  //console.log(events);
  //console.log(timeline);
  return renderTimeline;
}
